export const config = {
    apiKey: "AIzaSyCcC4MS5miQiDr1tJPYKuIyA7sjamKs3ds",
    authDomain: "isoft-trivia-01.firebaseapp.com",
    databaseURL: "https://isoft-trivia-01.firebaseio.com",
    projectId: "isoft-trivia-01",
    storageBucket: "isoft-trivia-01.appspot.com",
    messagingSenderId: "953335592275"
};


// WEBPACK FOOTER //
// ./src/helpers/firebaseConfig.js